import React, { PureComponent } from "react";
import DepositLimitsComponent from "@tvg/deposit-limits";

import perf from "../utils/perf";

class RgDepositLimits extends PureComponent {
  static defaultProps = {
    device: "mobile"
  };

  componentDidUpdate() {
    perf.measure("page_render", { page: "deposit_limits" });
  }

  render() {
    return <DepositLimitsComponent device={this.props.device} />;
  }
}

export default RgDepositLimits;
